import authApi from "../api/authApi";


const uploadImage = async (file) => {
    try {
        const { data: { presignedUrl, imageUrl } } = await authApi.post('/upload', {
            fileName: file.name, fileType: file.type,
        });
        await fetch(presignedUrl, {
            method: 'PUT',
            body: file,
        });
        return imageUrl
    } catch (error) {
        console.error('Error uploading file:', error);
        throw new Error('File upload failed.');
    }
};

export default uploadImage;